export default function mergeKnownProperties(obj1: any, obj2: any) {
  Object.keys(obj2).forEach(function (key) {
    if (key in obj1) {
      obj1[key] = obj2[key];
    }
  });
}
